var NEW_ADDRESS_DATE = new Date('17 June 2025 23:00:00 UTC'); // 18th June 2025 00:00 in BST

var isAfterNewAddressDate = function isAfterNewAddressDate() {
  var currentDate = new Date();
  return currentDate.getTime() >= NEW_ADDRESS_DATE.getTime();
};

export { isAfterNewAddressDate };